export const languages = [
  { name: 'English', code: 'en', flag: 'en-us.png' },
  { name:'Español', code: 'es', flag: 'es.png' },
  { name:'हिन्दी', code:'hi', flag:'hi.png' },
  { name:'বাংলা', code:'bn', flag:'bn.png' },
  {name:'Português',code:'pt',flag:'pt.png'},
  {name:'Русский',code:'ru',flag:'ru.png'},
  {name:'日本語',code:'ja',flag:'ja.png'},
  { name: 'Melayu', code: 'ms', flag: 'ms.png' },
  { name: 'عربي', code: 'ar', flag: 'ar.png' },
  { name: 'Azərbaycan', code: 'az', flag: 'az.png' },
  { name: '中文', code: 'zh', flag: 'zh-cn.webp' },
]

export const getLanguageFlagUrl = (filename) => {
  return new URL(`/src/assets/static/icon/lang_icon/${filename}`, import.meta.url).href
}
